/**
 * Pre-launch access gate.
 *
 * Public visitors can preview the homepage, waitlist, testimonials,
 * therapist directory, therapist application, and all legal/marketing
 * pages. The actual in-app tools (journal, breathing, grounding, etc.)
 * are locked until founding-member access opens. Admins bypass the gate.
 */

const LOCKED_EXACT = new Set<string>([
  "/journal",
  "/guided-journal",
  "/dreams",
  "/sleep-dreams",
  "/sleep",
  "/check-in",
  "/mood",
  "/breathing",
  "/grounding",
  "/somatic",
  "/tapping",
  "/bilateral",
  "/quick-resets",
  "/sounds",
  "/meditations",
  
  "/shadow-work",
  "/library",
  "/flashcards",
  "/workbooks",
  "/yoga",
  "/quiz",
  "/creative-reflection",
  
  "/holistic-wellbeing",
  "/my-healing-journey",
  "/art-board",
  "/favorites",
  "/explore",
  
  "/courses",
  "/community",
  "/dashboard",
  "/profile",
  "/preferences",
  "/account/privacy",
  "/settings/accessibility",
  "/nervous-system",
  "/therapy-approaches",
]);

const LOCKED_PREFIXES = [
  "/journal/",
  "/dreams/",
  "/library/",
  
  "/courses/",
  "/community/",
  "/dashboard/",
];

import { isMembershipPublic } from "./membership-launch";

export function isLaunchLockedPath(pathname: string): boolean {
  const p = pathname.replace(/\/+$/, "") || "/";
  // When the public-launch flag is on, the whole app is open — nothing
  // should show the pre-launch "Launching soon" screen. This also covers
  // post-Stripe-checkout redirects (/welcome, /dashboard) where the auth
  // session may not be fully rehydrated yet.
  if (isMembershipPublic()) return false;
  if (LOCKED_EXACT.has(p)) return true;
  for (const pre of LOCKED_PREFIXES) {
    if (p.startsWith(pre)) return true;
  }
  return false;
}
